// extracted by mini-css-extract-plugin
module.exports = {"badge":"SimpleCard_badge__37Nuo"};